/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<g fill-rule="nonzero"><path pid="0" d="M34.866 4.117h-9.035V0H13.562v4.117H4.527v6.502h30.339zm-18.053-.866h5.768v.866h-5.768zM31.979 23.221l.614-9.352H6.801l2.061 31.422h12.37a13.945 13.945 0 01-2.557-8.064c0-7.492 5.905-13.63 13.304-14.006z"/><path pid="1" d="M32.699 26.453c-5.94 0-10.773 4.833-10.773 10.774 0 5.94 4.833 10.773 10.773 10.773 5.941 0 10.774-4.833 10.774-10.773 0-5.941-4.833-10.774-10.774-10.774zm5.87 14.345l-2.298 2.299-3.572-3.572-3.572 3.572-2.298-2.299 3.572-3.571-3.572-3.572 2.298-2.299 3.572 3.572 3.572-3.572 2.298 2.299-3.571 3.572z"/></g>'
}
